module.exports = __webpack_public_path__ + "static/media/Spacey Curry.50e0cc3a.jpg";